var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as moment from 'moment';
import { PREDEFINED_EOD_RANGES, TRADING_EVENT_TYPE } from '../util/constants';
import { areOpenAndCloseEvents, createIntervalsFromRange, detectSpanFromRange } from '../util/moment';
import { HighChartDataProviderConfig } from './HighChartDataProviderConfig';
var GRANULARITY_INTRADAY = 5;
var GRANULARITY_ONE_WEEK = 30;
/**
 * Handling of data request to generic price EPs
 */
var HighChartDataProvider = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param client
     * @param config
     */
    function HighChartDataProvider(client, config) {
        /**
         * Last open/close trading events
         */
        this.infoData = new Map();
        this.client = client;
        this.intradayNoDataRetried = 0;
        this.config = __assign(__assign({}, new HighChartDataProviderConfig()), config);
    }
    /**
     * Fetches price data with given params
     *
     * @param params
     */
    HighChartDataProvider.prototype.getData = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var id, infoData, _a, _b, pricesData, _c, _d, prices, data;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        id = String(params.idNotation);
                        if (!!this.infoData.get(id)) return [3 /*break*/, 3];
                        _a = this.transformInfo;
                        _b = [params];
                        return [4 /*yield*/, this.getLastTradingEvents(params)];
                    case 1: return [4 /*yield*/, _a.apply(this, _b.concat([_e.sent()]))];
                    case 2:
                        infoData = _e.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        infoData = this.infoData.get(id);
                        _e.label = 4;
                    case 4:
                        _c = this.transformData;
                        _d = [params];
                        return [4 /*yield*/, this.getPrices(params)];
                    case 5:
                        pricesData = _c.apply(this, _d.concat([_e.sent()]));
                        prices = __spreadArrays(pricesData.DATA[0].PRICES);
                        if (!(params.timeSpan === 'INTRADAY' && prices.length === 0 && this.intradayNoDataRetried < this.config.INTRADAY_NODATA_RETRIES)) return [3 /*break*/, 7];
                        this.intradayNoDataRetried += 1;
                        return [4 /*yield*/, this.getData(params)];
                    case 6: return [2 /*return*/, _e.sent()];
                    case 7:
                        // Adjust trading open and close
                        if (params.timeSpan === 'INTRADAY' && this.intradayNoDataRetried > 0 && prices.length > 1) {
                            infoData.INFO.TRADING_DAY_OPEN = prices.shift()[0];
                            infoData.INFO.TRADING_DAY_CLOSE = prices.pop()[0];
                            this.intradayNoDataRetried = 0;
                        }
                        data = __assign(__assign({}, pricesData), infoData);
                        return [2 /*return*/, { data: data }];
                }
            });
        });
    };
    /**
     * Find last trading open and close time events
     *
     * @param params
     */
    HighChartDataProvider.prototype.getLastTradingEvents = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var id, endpoint, events, retries, _i, retries_1, retry, start, end, requestData, res, open_1, close_1, tzOffset, openEvent, closeEvent;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        id = String(params.idNotation);
                        endpoint = this.config.API_PRICES_TRADING_SCHEDULE_EVENT_LIST;
                        events = [];
                        retries = Array.from(Array(10).keys());
                        _i = 0, retries_1 = retries;
                        _a.label = 1;
                    case 1:
                        if (!(_i < retries_1.length)) return [3 /*break*/, 4];
                        retry = retries_1[_i];
                        start = moment().utc().subtract(retry, 'day').startOf('day');
                        end = moment().utc().subtract(retry, 'day').endOf('day');
                        requestData = {
                            data: {
                                id: id,
                                filter: {
                                    types: [TRADING_EVENT_TYPE.OPEN, TRADING_EVENT_TYPE.CLOSE],
                                    range: { start: start.toISOString(), end: end.toISOString() },
                                },
                            },
                        };
                        return [4 /*yield*/, this.client.requestEndpoint('POST', endpoint, requestData)];
                    case 2:
                        res = _a.sent();
                        // Retry when no events found
                        if (res.data.events.length !== 2) {
                            return [3 /*break*/, 3];
                        }
                        open_1 = res.data.events.find(function (e) { return Number(e.type.id) === TRADING_EVENT_TYPE.OPEN; });
                        close_1 = res.data.events.find(function (e) { return Number(e.type.id) === TRADING_EVENT_TYPE.CLOSE; });
                        tzOffset = moment(open_1.time).utcOffset();
                        openEvent = moment(open_1.time).utc();
                        closeEvent = moment(close_1.time).utc();
                        // Retry when market is not opened
                        if (moment().utc().valueOf() < openEvent.valueOf()) {
                            return [3 /*break*/, 3];
                        }
                        // Fallback to current day when it is not normal events
                        if (!areOpenAndCloseEvents(openEvent, closeEvent)) {
                            openEvent = moment().utc().startOf('day');
                            closeEvent = moment().utc().endOf('day');
                        }
                        events = [openEvent, closeEvent, tzOffset];
                        return [3 /*break*/, 4];
                    case 3:
                        _i++;
                        return [3 /*break*/, 1];
                    case 4: return [2 /*return*/, events];
                }
            });
        });
    };
    /**
     * Build requests from given params
     *
     * @param params
     */
    HighChartDataProvider.prototype.getPrices = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var results, prices;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createRequests(params)];
                    case 1:
                        results = _a.sent();
                        prices = [];
                        results.forEach(function (res) {
                            var chunk = res.data.prices || res.data.subsamples || [];
                            prices.push.apply(prices, chunk);
                        });
                        return [2 /*return*/, prices];
                }
            });
        });
    };
    /**
     * Create multiple requests
     *
     * @param params
     */
    HighChartDataProvider.prototype.createRequests = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.all(this.buildRequestsList(params).map(function (r) {
                        var endPoint = r.endPoint, data = r.data, meta = r.meta;
                        return _this.client.requestEndpoint('POST', endPoint, { data: data, meta: meta });
                    }))];
            });
        });
    };
    /**
     * Transform prices response
     *
     * @param params
     * @param res
     */
    HighChartDataProvider.prototype.transformData = function (params, res) {
        var volumes = [];
        var prices = [];
        var ohlcVolume = [];
        var halfDayInMs = 1000 * 12 * 60 * 60;
        res.forEach(function (entry) {
            var timeStamp = entry.time ? moment(entry.time).utc().valueOf() : moment(entry.date).utc().valueOf() + halfDayInMs;
            volumes.push([timeStamp, entry.tradingVolume]);
            prices.push([timeStamp, entry.last]);
            ohlcVolume.push([timeStamp, entry.first, entry.high, entry.low, entry.last, entry.tradingVolume]);
        });
        var data = {
            DATA: [
                {
                    VOLUME: volumes,
                    PRICES: prices,
                    OHLC_VOLUME: ohlcVolume,
                    TIME_SPAN: params.timeSpan,
                },
            ],
        };
        return data;
    };
    /**
     * Parse open/close trading event time for using in intraday
     *
     * @param res
     */
    HighChartDataProvider.prototype.transformInfo = function (params, res) {
        return __awaiter(this, void 0, void 0, function () {
            var id, priceInfo, _a, openEvent, closeEvent, tzOffset, info;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = String(params.idNotation);
                        return [4 /*yield*/, this.getPriceInfo(id)];
                    case 1:
                        priceInfo = _b.sent();
                        _a = __spreadArrays(res), openEvent = _a[0], closeEvent = _a[1], tzOffset = _a[2];
                        info = {
                            INFO: {
                                SERVER_TIMEZONE_OFFSET: tzOffset,
                                TRADING_DAY_OPEN: openEvent.valueOf(),
                                TRADING_DAY_CLOSE: closeEvent.valueOf(),
                                TRADING_LATEST: moment(priceInfo.latest.time).utc().valueOf(),
                                PREVIOUS_CLOSE: moment(priceInfo.previousClose.time).utc().valueOf(),
                            },
                        };
                        this.infoData.set(id, info);
                        return [2 /*return*/, info];
                }
            });
        });
    };
    /**
     * Build list of requests data
     *
     * @param params
     */
    HighChartDataProvider.prototype.buildRequestsList = function (params) {
        var _a;
        var id = String(params.idNotation);
        var list = [];
        var quality = this.config.API_PRICES_QUALITY;
        var granularity = params.granularity;
        var granularityString = granularity + "m";
        var endPoint;
        var start;
        var end;
        var intervals;
        switch (params.timeSpan) {
            case 'INTRADAY':
                if (!granularity) {
                    granularity = GRANULARITY_INTRADAY;
                    granularityString = '5m';
                }
                var now = moment().utc();
                var INFO = this.infoData.get(id).INFO;
                if (this.intradayNoDataRetried > 0) {
                    start = moment(INFO.TRADING_DAY_OPEN).utc().subtract(this.intradayNoDataRetried, 'day');
                    end = moment(INFO.TRADING_DAY_CLOSE).utc().subtract(this.intradayNoDataRetried, 'day');
                }
                else {
                    start = moment(INFO.TRADING_DAY_OPEN).utc();
                    end = now;
                    if (now.valueOf() > INFO.TRADING_DAY_CLOSE) {
                        end = moment(INFO.TRADING_DAY_CLOSE).utc();
                    }
                }
                var minuteDivisibleBy5Start = Math.floor(start.get('minute') / granularity) * granularity;
                start = moment(start).utc().minute(minuteDivisibleBy5Start).startOf('minute');
                var minuteDivisibleBy5End = Math.floor(end.get('minute') / granularity) * granularity + granularity;
                end = moment(end).utc().minute(minuteDivisibleBy5End).startOf('minute');
                endPoint = this.config.API_PRICES_TSS_INTRADAY_SUBSAMPLE_LIST;
                break;
            case 'ONE_WEEK':
                if (!granularity) {
                    granularity = GRANULARITY_ONE_WEEK;
                    granularityString = '30m';
                }
                start = moment().utc().subtract(1, 'week').startOf('hour');
                var minuteDivisibleBy30 = Math.floor(moment().utc().get('minute') / granularity) * granularity;
                end = moment().utc().minute(minuteDivisibleBy30).startOf('minute');
                endPoint = this.config.API_PRICES_TSS_INTRADAY_SUBSAMPLE_LIST;
                break;
            default:
                if (PREDEFINED_EOD_RANGES[params.timeSpan]) {
                    // We need to remove the granularity string in this case
                    granularityString = undefined;
                    // Checks predefined EOD ranges
                    var _b = __assign({}, PREDEFINED_EOD_RANGES[params.timeSpan]), _c = _b.diffOperator, diffOperator = _c === void 0 ? 'substract' : _c, _d = _b.diff, diff = _d === void 0 ? [1, 'year'] : _d, _e = _b.diffStartOf, diffStartOf = _e === void 0 ? 'day' : _e, _f = _b.diffIntervals, diffIntervals = _f === void 0 ? null : _f;
                    if (diffOperator === 'substract') {
                        start = (_a = moment().utc()).subtract.apply(_a, diff).startOf(diffStartOf);
                    }
                    else if (diffOperator === 'startOf') {
                        start = moment().utc().startOf(diff[0]).startOf(diffStartOf);
                    }
                    else {
                        throw new Error("diffOperator is not defined for given " + params.timeSpan);
                    }
                    end = moment().utc().startOf('day');
                    endPoint = this.config.API_PRICES_TSS_EOD_LIST;
                    if (diffIntervals) {
                        endPoint = this.config.API_PRICES_TSS_EOD_SUBSAMPLE_LIST;
                        intervals = createIntervalsFromRange.apply(void 0, __spreadArrays([start, end], diffIntervals));
                    }
                }
                else {
                    // Parse the range from given string
                    var _g = detectSpanFromRange(params.timeSpan), _start = _g.start, _end = _g.end, period = _g.period, interval = _g.interval;
                    endPoint = this.config.API_PRICES_TSS_EOD_SUBSAMPLE_LIST;
                    start = _start;
                    end = _end;
                    intervals = createIntervalsFromRange(start, end, period, interval);
                }
                break;
        }
        var request = {
            endPoint: endPoint,
            data: {
                quality: quality, id: id,
                granularity: granularityString,
                type: params.priceType ? params.priceType : 'trade',
                range: { start: start.toISOString(), end: end.toISOString() },
            },
            meta: {
                pagination: {
                    limit: 500,
                },
            },
        };
        if (intervals instanceof Array) {
            var INFO = this.infoData.get(id).INFO;
            // This is for the latest close to be included
            var lastInterval = moment(intervals.pop());
            var tradingLatest = moment(INFO.TRADING_LATEST).utc();
            var previousClose = moment(INFO.PREVIOUS_CLOSE).utc();
            var tradingLatestInterval = [tradingLatest.startOf('day'), moment(tradingLatest).add(1, 'day').startOf('day')];
            var previousCloseInterval = [];
            if (lastInterval.isSame(tradingLatest, 'day')) {
                previousCloseInterval.push(moment(tradingLatest).add(1, 'day').startOf('day'));
            }
            else if (lastInterval.isBefore(previousClose, 'day') && tradingLatest.isSame(moment().utc().startOf('day'), 'day')) {
                previousCloseInterval.push(previousClose.startOf('day'));
            }
            this.pushMoments.apply(this, __spreadArrays([intervals, lastInterval], previousCloseInterval, tradingLatestInterval));
            var eodRequest = __assign({}, request);
            eodRequest.data.range = undefined;
            eodRequest.data.intervals = intervals;
            list.push(eodRequest);
        }
        else {
            list.push(request);
        }
        return list;
    };
    /*
      Appends the Moment objects from the array "additionalElements" to the array "intervals", as long as they form a strictly monotonically increasing sequence.
      Leaves out all elements which are less or equal than the already existing element at the end of the target array.
    */
    HighChartDataProvider.prototype.pushMoments = function (intervals) {
        var additionalElements = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            additionalElements[_i - 1] = arguments[_i];
        }
        if (additionalElements) {
            if (intervals.length > 0) {
                var lastInterval = intervals[intervals.length - 1];
                for (var _a = 0, additionalElements_1 = additionalElements; _a < additionalElements_1.length; _a++) {
                    var additionalElement = additionalElements_1[_a];
                    var difference = additionalElement - lastInterval;
                    if (difference > 0) {
                        intervals.push(additionalElement);
                    }
                    lastInterval = additionalElement;
                }
            }
            else {
                intervals.push(additionalElements);
            }
        }
    };
    /**
     * Fetches price info
     *
     * @param id
     */
    HighChartDataProvider.prototype.getPriceInfo = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var data, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = {
                            id: id,
                            quality: this.config.API_PRICES_QUALITY,
                        };
                        return [4 /*yield*/, this.client.requestEndpoint('GET', this.config.API_PRICES_GET, data)];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res.data];
                }
            });
        });
    };
    return HighChartDataProvider;
}());
export { HighChartDataProvider };
//# sourceMappingURL=HighChartDataProvider.js.map